import {
  Box,
  Button,
  Center,
  Flex,
  Loader,
  Modal,
  Pagination,
  Paper,
  Select,
  Space,
  Stack,
  Table,
  Text,
  Title,
  UnstyledButton,
  createStyles,
} from "@mantine/core";
import Buttonfilter from "../../assets/img/Icon Button.svg";
import { Input, Tooltip } from "@mantine/core";
import plus from "../../assets/img/pluss.svg";
import searchIcon from "../../assets/img/searchIcon.svg";
import { ClinicalCards } from "./ClinicalCards";
import { useNavigate } from "react-router-dom";
import { StatusBadge, useMedplum } from "@medplum/react";
import { useEffect, useState } from "react";
import { getConfig } from "../../config";
import axios from "axios";
import { useSelector } from "react-redux";
import { AppState } from "../../store/types/appState";
import { epicHandler, filterByValueString } from "../../utils";

import {
  SelectItem,
  documentRefrenceForPatient,
  downloadForDocrefrence,
  fetchPatientList,
} from "./clinicalNotesService";
import { showNotification } from "@mantine/notifications";
import { MedplumClient, formatDate, formatDateTime } from "@medplum/core";
import { CustomTable } from "../../components/Table";
import { PatientNotFound } from "../Patient/PatientVisits/DataNotFound";
import { IconDownload,IconDetails } from "@tabler/icons-react";
import { setuid } from "process";
import { IconFileText } from "@tabler/icons-react";
const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  heading: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  searcbar: {
    width: "100%",
    gap: "24px",
    paddingTop: "24px",
    paddingBottom: "16px",
  },
  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
  downloadLoader: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(0.5px)",
    zIndex: 9999,
  },
}));
export const Clinicalnotes = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const ButtonClick = () => {
    navigate("new-clinical_Notes");
  };
  const editclick = () => {
    navigate("Edit_Clinical_notes");
  };
  const deleteClicks = () => {};
  const medplum = useMedplum();
  const config = getConfig();
  const [resource, setResource] = useState<any>([]);
  const [total, setTotal] = useState<any>("");
  const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);



  const [searchQuery, setSearcQuery] = useState<string>("");
  const [patientList, setPatientList] = useState<any>([""]);
  const [selctedPatient, setselectedPatient] = useState<any>(
    null
  );
  const [isLoading, setIsloading] = useState<boolean>(false);
    const [isDownloading, setisDownloading] = useState<any>("");

    const [data, setdata] = useState<any>("");
    const[blobUrl,setblobUrl]=useState<any>("")


  const [ispatientfetched, setisPateintFetched] = useState<boolean>(false);
   const tableHeaders = [
     "Report Name",
     "Category",
     "Date Issued On",
     "Status",
     "View Notes",
   ];

  const logginedUser = useSelector((state: AppState) => state) as any;
  const statuss: any[] = logginedUser?.app?.profile?.extension || [];
  const epicObject = statuss.find((item) =>
    item.extension.some(
      (ext: any) => ext.url === "integrationType" && ext.valueString === "epic"
    )
  );
  const accessToken = epicObject
    ? epicObject?.extension?.find((ext: any) => ext?.url === "access_token")
        ?.valueString
    : null;

 
  useEffect(() => {
    docmentRefForpatient(selctedPatient,1);
  }, [selctedPatient]);
   useEffect(() => {
     patientSearch();
     
   }, []);
  
   
  const patientSearch = async () => {
    try {
      setisPateintFetched(true);
      fetchPatientList( medplum,true)
        .then((patientListData) => {
        
             const patient = patientListData.map((patient)=>{
              return patient
             })
             setselectedPatient(patient[0]?.value)
          setPatientList(patientListData);
          setisPateintFetched(false);
        })
        .catch((error) => {
          console.error("Error fetching patient list:", error);
          setisPateintFetched(false);
        });
    } catch (error) {
      setisPateintFetched(false);
      // Handle any synchronous errors (if needed)
      console.error("Error fetching patient list:", error);
      showNotification({
        color: "red",
        message: "Failed",
        autoClose: true,
      });
    }
  };
  const onSearchChange = (value: any) => {
    setSearcQuery(value);
  };
  const handleChange = (value: any) => {
    setselectedPatient(value);
  };

  const docmentRefForpatient = (Id: string,pageNumber:any) => {
    try {
      setIsloading(true);
      documentRefrenceForPatient(Id, medplum,pageNumber)
        .then((docRefrenceData: any) => {
          const totalpages = Math.ceil(
            (docRefrenceData.bundle.total as any) / 20
          );

          setTotal(totalpages);
          setResource(docRefrenceData)
          
          setIsloading(false);
        })
        .catch((error) => {
          console.error("Error fetching patient list:", error);
          setIsloading(false);
        });
    } catch (error) {
      setIsloading(false);
      console.error("Error fetching patient list:", error);
      showNotification({
        color: "red",
        message: "Failed",
        autoClose: true,
      });
    }
  };
  const handlePageChange = (page: number) => {
        setCurrentPage(page);

    if (selctedPatient) {
    docmentRefForpatient(selctedPatient, page);
    }
    
  };
  
   const getCategory = (category: any) => {
     let text = "";
     if (category?.length > 0) {
       for (let i = 0; i < category?.length; i++) {
         if (category[i].coding) {
           for (let j = 0; j < category[i].coding?.length; j++) {
             text = category[i].coding[j].display;
           }
         }
       }
       return text;
     }
   };
   const downloadFile = (Docrefid: any, medplum: MedplumClient) => {
    setisDownloading(true)
    downloadForDocrefrence(Docrefid,medplum).then((response:any)=>{
      setblobUrl(response)
                setIsModalOpen(true);


      setisDownloading(false)
    }).catch((error)=>{
      console.error(error)
          setisDownloading(false);


    })
   };

  return (
    
    <>
    
      {" "}
      <Modal
        title={"Clinical Notes"}
        size={"xl"}
        opened={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);

          setblobUrl("");
        }}
        withCloseButton={true}
        closeOnEscape={true}
        closeOnClickOutside={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingBottom: "12px",
          }}
        ></Box>

        <div id="file-viewer" style={{ width: "100%", height: "100%" }}>
          <Text>Description</Text>
          <Box sx={{ border: "1px solid #BEDEF8", borderRadius: "6px" }}>
            {blobUrl && (
              <iframe
                title="PDF Viewer"
                src={blobUrl}
                style={{ width: "100%", height: "76vh", border: "none" }}
              />
            )}
          </Box>
        </div>
      </Modal>
      <Paper className={classes.default}>
        <Box sx={{}}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Title className={classes.heading}>Clinical Notes</Title>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Button
                    sx={{ backgroundColor: "#1B75BC" }}
                    onClick={ButtonClick}
                  >
                    <Box sx={{ marginRight: "8px" }}>
                      <img src={plus} />
                    </Box>
                    <Text sx={{ display: "flex", paddingTop: "2px" }}>
                      New Clinical Note{" "}
                    </Text>
                  </Button>
                </Box>
              </Box>
              <Box className={classes.searcbar}>
                <Select
                  label="Select patient"
                  placeholder={
                    ispatientfetched
                      ? "Fetching patient list..."
                      : "Search Patients"
                  }
                  rightSection={ispatientfetched ? <Loader size={"sm"} /> : ""}
                  icon={<img src={searchIcon} />}
                  required={true}
                  defaultValue={selctedPatient}
                  data={patientList}
                  mt="lg"
                  size="lg"
                  radius="md"
                  value={selctedPatient}
                  onChange={(val: any) => {
                    setselectedPatient(val);
                  }}
                  clearable={true}
                  sx={{
                    ".mantine-Select-itemsWrapper": {
                      paddingRight: "10px",
                    },
                  }}
                  searchable
                  itemComponent={SelectItem}
                />
              </Box>
            </Box>
            <Box>
              <Box sx={{ paddingBottom: "16px" }}>
                {isLoading ? (
                  <Center className={classes.loader}>
                    <Loader />
                  </Center>
                ) : (
                  <>
                    {resource.length === 0 ? (
                      <Box>
                        {" "}
                        <Center style={{ width: "100%", height: "200px" }}>
                          <Text size="xl" color="dimmed">
                            No results
                          </Text>
                        </Center>
                      </Box>
                    ) : (
                      <Table className={classes.table}>
                        <thead className={classes.thead}>
                          <tr>
                            {tableHeaders?.map((val) => {
                              return <th key={val}>{val}</th>;
                            })}
                          </tr>
                        </thead>
                        {
                          <tbody>
                            {resource?.map((data: any) => (
                              <tr key={data?.id}>
                                <td>{data?.content[0]?.attachment?.title}</td>
                                <td>{getCategory(data?.category)}</td>
                                <td>{formatDateTime(data?.date)}</td>
                                <td>
                                  <StatusBadge
                                    status={data?.docStatus as string}
                                  />
                                </td>
                                <td
                                  onClick={() => {
                                    setdata(data?.content[0]?.attachment?.url);
                                    downloadFile(data?.id, medplum);
                                  }}
                                >
                                  <IconFileText
                                    color="#228be6"
                                    style={{
                                      marginRight: "10px",
                                      marginLeft: "25px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        }
                      </Table>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "18px",
                      }}
                    >
                      <Pagination
                        total={total}
                        onChange={handlePageChange}
                        defaultValue={currentPage}
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        {isDownloading && (
          <Center className={classes.downloadLoader}>
            <Loader />
          </Center>
        )}
      </Paper>
    </>
  );
};
